import CrossSmall from '@spectrum-icons/ui/CrossSmall';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A tag rendered inside the `MultiSelect` trigger area.
 * Private subcomponent of `MultiSelect`.
 */
export function MultiSelectTag(_ref) {
  var tagKey = _ref.tagKey,
    label = _ref.label,
    isDisabled = _ref.isDisabled,
    isReadOnly = _ref.isReadOnly,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/_jsxs("span", {
    className: "dh-multi-select-tag",
    children: [/*#__PURE__*/_jsx("span", {
      className: "dh-multi-select-tag-label",
      children: label
    }), !isDisabled && !isReadOnly && /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "dh-multi-select-tag-remove",
      tabIndex: -1,
      "aria-label": "Remove ".concat(label)
      // Prevent the search input from losing focus when the user clicks the tag's remove
      // button. `onPointerDown` fires before the input's blur, so suppressing its default
      // keeps focus on the input.
      ,
      onPointerDown: e => e.preventDefault(),
      onClick: () => onRemove(tagKey),
      children: /*#__PURE__*/_jsx(CrossSmall, {})
    })]
  });
}
export default MultiSelectTag;
//# sourceMappingURL=MultiSelectTag.js.map